export type OfferChangeCounts = {
  requested: number;
  applied: number;
  notRetained: number;
  pending: number;
};
export type OfferChangeSummary = {
  upgrades: OfferChangeCounts;
  downgrades: OfferChangeCounts;
  pairs: Array<
    OfferChangeCounts & { from: string; to: string; direction: 'UPGRADE' | 'DOWNGRADE' }
  >;
};
export function isOfferChangeSummary(value: unknown): value is OfferChangeSummary {
  const record = (v: unknown): v is Record<string, unknown> =>
    typeof v === 'object' && v !== null && !Array.isArray(v);
  const counts = (v: unknown): v is OfferChangeCounts =>
    record(v) &&
    ['requested', 'applied', 'notRetained', 'pending'].every(
      (key) => Number.isSafeInteger(v[key]) && Number(v[key]) >= 0,
    ) &&
    v.requested === Number(v.applied) + Number(v.notRetained) + Number(v.pending);
  return (
    record(value) &&
    counts(value.upgrades) &&
    counts(value.downgrades) &&
    Array.isArray(value.pairs) &&
    value.pairs.every(
      (pair) =>
        record(pair) &&
        typeof pair.from === 'string' &&
        typeof pair.to === 'string' &&
        ['UPGRADE', 'DOWNGRADE'].includes(String(pair.direction)) &&
        counts(pair),
    )
  );
}
